import React, { useState, useContext } from 'react'
import { api } from '../api/axios';
import { toast } from 'react-toastify';
import { AuthContext } from '../context/AuthContext';




export default function PollForm() {

    const { setLoading } = useContext(AuthContext);

    const [newPoll, setNewPoll] = useState({
        question: '',
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        correctOption: '',
    });
    const [pollType, setPollType] = useState('text');

    const handelChangePollData = (e) => {
        const { name, value } = e.target;
        if (e.target.type === 'file') {
            const file = e.target.files[0]

            setNewPoll({
                ...newPoll,
                [name]: file
            });
        } else {
            setNewPoll({
                ...newPoll,
                [name]: value
            });
        }

    }

    const handleTogglePollType = async (value) => {
        setPollType(value)
        setNewPoll({
            question: '',
            option1: '',
            option2: '',
            option3: '',
            option4: '',
            correctOption: '',
        })
    }

    const handelRegisterNewPoll = async (e) => {
        e.preventDefault();
        try {

            if (pollType === 'text') {
                setLoading(true);
                const respons = await api.post('/polls', {
                    pollType: pollType,
                    ...newPoll,
                    correctOption: newPoll.correctOption || null,
                })

                if (respons.status === 201) {
                    toast.success("New Poll Created Successfully")
                }
            } else {

                const formData = new FormData()
                formData.append('question', newPoll.question)
                formData.append('pollType', pollType)
                formData.append('option1', newPoll.option1)
                formData.append('option2', newPoll.option2)
                formData.append('option3', newPoll.option3)
                formData.append('option4', newPoll.option4)
                if (newPoll.correctOption) formData.append('correctOption', newPoll.correctOption)


                setLoading(true);
                const respons = await api.post('/polls', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })

                if (respons.status === 201) {
                    toast.success("New Poll Created Successfully")

                }
            }

        } catch (error) {
            if (error.status === 409) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.response.data.message)
            }

            console.error(error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    }

    return (
        <>
            <form onSubmit={handelRegisterNewPoll}>
                <div className="border-b border-gray-900/10 pb-6">
                    <h2 className="text-base font-semibold text-gray-900">Poll Information</h2>

                    <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-8 ms-5">
                        <div className="sm:col-span-6">
                            <label htmlFor="question" className="block text-sm/6 font-medium text-gray-900">
                                Question <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                <input
                                    id="question"
                                    name="question"
                                    type="text"
                                    value={newPoll.question}
                                    onChange={handelChangePollData}
                                    required={true}
                                    className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="typePoll" className="block text-sm/6 font-medium text-gray-900">
                                Poll Type <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                <select name="typePoll"
                                    id="typePoll"
                                    value={pollType}
                                    onChange={(e) => handleTogglePollType(e.target.value)}
                                    className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6">
                                    <option value="text">Text</option>
                                    <option value="image">Image</option>
                                </select>
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="option1" className="block text-sm/6 font-medium text-gray-900">
                                Option A <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                {
                                    pollType === 'text' ?
                                        <input
                                            id="option1"
                                            name="option1"
                                            type="text"
                                            value={newPoll.option1}
                                            onChange={handelChangePollData}
                                            required={true}
                                            className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                        />
                                        :
                                        <input
                                            id="option1"
                                            name="option1"
                                            type="file"
                                            onChange={handelChangePollData}
                                            required={true}
                                            accept='image/jpeg, image/png'
                                            className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                        />
                                }

                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="option2" className="block text-sm/6 font-medium text-gray-900">
                                Option B <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                {
                                    pollType === "text" ?
                                        <input
                                            id="option2"
                                            name="option2"
                                            type="text"
                                            value={newPoll.option2}
                                            onChange={handelChangePollData}
                                            required={true}
                                            className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                        />
                                        : <input
                                            id="option2"
                                            name="option2"
                                            type="file"
                                            onChange={handelChangePollData}
                                            required={true}
                                            accept='image/jpeg, image/png'
                                            className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                        />
                                }
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="option3" className="block text-sm/6 font-medium text-gray-900">
                                Option C <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                {
                                    pollType === 'text' ?
                                        <input
                                            id="option3"
                                            name="option3"
                                            type="text"
                                            value={newPoll.option3}
                                            onChange={handelChangePollData}
                                            required={true}
                                            className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                        />
                                        : <input
                                            id="option3"
                                            name="option3"
                                            type="file"
                                            onChange={handelChangePollData}
                                            required={true}
                                            accept='image/png, image/jpeg'
                                            className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                        />
                                }
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="option4" className="block text-sm/6 font-medium text-gray-900">
                                Option D <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                {
                                    pollType === 'text' ?
                                        <input
                                            id="option4"
                                            name="option4"
                                            type="text"
                                            value={newPoll.option4}
                                            onChange={handelChangePollData}
                                            required={true}
                                            className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                        />
                                        : <input
                                            id="option4"
                                            name="option4"
                                            type="file"
                                            onChange={handelChangePollData}
                                            required={true}
                                            accept='image/jpeg, image/png'
                                            className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                        />
                                }
                            </div>
                        </div>
                        <div className="col-span-full">
                            <label htmlFor="correctOption" className="block text-sm/6 font-medium text-gray-900">
                                Correct answer <span className="text-xs text-gray-500">(optional)</span>
                            </label>
                            <select
                                id="correctOption"
                                name="correctOption"
                                value={newPoll.correctOption || ''}
                                onChange={handelChangePollData}
                                className="mt-2 px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                            >
                                <option value="">— None —</option>
                                {pollType === 'text' ? (
                                    <>
                                        {newPoll.option1 && <option value={newPoll.option1}>A: {newPoll.option1}</option>}
                                        {newPoll.option2 && <option value={newPoll.option2}>B: {newPoll.option2}</option>}
                                        {newPoll.option3 && <option value={newPoll.option3}>C: {newPoll.option3}</option>}
                                        {newPoll.option4 && <option value={newPoll.option4}>D: {newPoll.option4}</option>}
                                    </>
                                ) : (
                                    <>
                                        <option value="option1">A (image)</option>
                                        <option value="option2">B (image)</option>
                                        <option value="option3">C (image)</option>
                                        <option value="option4">D (image)</option>
                                    </>
                                )}
                            </select>
                            <p className="mt-1 text-xs text-gray-500">When set, the app will show this as the correct answer to users after they submit.</p>
                        </div>
                        <div className="col-span-full flex items-center justify-end gap-x-6">
                            <button
                                type="submit"
                                className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                            >
                                Save New Poll
                            </button>
                        </div>
                    </div>
                </div>



            </form>
        </>
    )
}
